
const state = {
    filterBlock: {},
    selectedFilter: { text: 'Active', value: 1 },
    countPosts: 10,
    selectedTab: 'All',
    chosenPage: 1,
};

const mutations = {
    setChosenPage(state, chosenPage) {
        state.chosenPage = chosenPage;
    },
    setSelectedFilter(state, filter) {
        state.selectedFilter = filter;
    },
    setCountPosts(state, countPosts) {
        state.countPosts = countPosts;
    },
};

const actions = {
    setChosenPage(state, chosenPage) {
        state.chosenPage = chosenPage;
    },
    updateSelectedFilter({ commit }, filter) {
        commit('setSelectedFilter', filter);
    },
    updateChosenPage({ commit }, chosenPage) {
        commit('setChosenPage', chosenPage);
    },
    updateCountPosts({ commit }, countPosts) {
        commit('setCountPosts', countPosts);
    },
};

const getters = {
    getChosenPage: (state) => state.chosenPage,
    getSelectedFilter: (state) => state.selectedFilter,
    getCountPosts: (state) => state.countPosts,
};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters,
};